import { useCustomerTypeService } from "../../sales"
import { useStockActions, useStockLoaders } from "../../stock"
import { useLotActions } from "../actions/lotActions"
import { useProductActions } from "../actions/productActions"
import { useProductPricesActions } from "../actions/productPricesActions_NEW"
import { useProductBuilders } from "../builders/productBuilders"
import { useLotLoaders } from "../loaders/lotLoaders"
import { useProductLoaders } from "../loaders/productLoaders"
import { useProductPricesLoaders } from "../loaders/productPricesLoaders"

export const useProductService = () => {
    const { buildProduct } = useProductBuilders()
    
    const productLoaders = useProductLoaders()
    const productPricesLoaders = useProductPricesLoaders()
    const lotLoaders = useLotLoaders()
    const stockLoaders = useStockLoaders()
    
    const productActions = useProductActions()
    const { removeProductPrices } = useProductPricesActions()
    const { removeLots } = useLotActions()
    const { removeStockList } = useStockActions()
    const { removeProductFromCustomerTypes } = useCustomerTypeService()

    const removeProduct = async (productId: string) => {
        const { loadProduct } = productLoaders()
        const product = await loadProduct(productId, true)
        
        await productActions.removeProductWithImage(product!.id)

        const { loadProductPrices } = productPricesLoaders()
        const productPrices = await loadProductPrices(product!.id, true)
        await removeProductPrices(productPrices!.id)

        const { loadProductStocks } = stockLoaders()
        const stocks = await loadProductStocks(product!.id)
        await removeStockList(stocks.map(stock => stock.id))

        const { loadProductLots } = lotLoaders()
        const lots = await loadProductLots(product!.id, true)
        await removeLots(lots.map(lot => lot.id))
    }

    const archiveProduct = async (productId: string) => {
        const { loadProduct } = productLoaders()
        const product = await loadProduct(productId, true)
        const archivedProduct = buildProduct({
            ...product,
            archived: true
        })
        const savedProduct = await productActions.saveProduct(archivedProduct)
        await removeProductFromCustomerTypes(productId)
        return savedProduct
    }

    return {
        removeProduct,
        archiveProduct
    }
}
